import { getCustomer } from '@/clients/shopify/client'
import { USER_ACCESS_POPS_TOKEN, USER_ACCESS_TOKEN } from '@/constants/shopify'
import { $customer, $authenticationToken } from '@/stores/account/stores'
import Cookie from 'js-cookie'

export const initCustomer = async () => {
  const accessToken = Cookie.get(USER_ACCESS_TOKEN)
  const accessTokenState = $authenticationToken.get()
  if (!accessToken || !accessTokenState) {
    $authenticationToken.set('')
    $customer.set(null)
    Cookie.remove(USER_ACCESS_TOKEN)
    Cookie.remove(USER_ACCESS_POPS_TOKEN)
    return
  }

  const customer = await getCustomer(accessToken)

  if (!customer) {
    Cookie.remove(USER_ACCESS_TOKEN)
    Cookie.remove(USER_ACCESS_POPS_TOKEN)
    $authenticationToken.set('')
    $customer.set(null)
    window.location.reload()
  }
}
